/*
    Create by Baizm 2015-11-13
*/
"use strict";
angular.module("politicalcommSenseModule", ["synchronous"])
    .controller("politicalcommSenseCtrl", ["$scope", "$q", "$modal", "$stateParams", 'trsHttpService', 'modalDialog', '$timeout', function($scope, $q, $modal, $stateParams, trsHttpService, modalDialog, $timeout) {
        init();

        //树配置开始
        var nodeId = "";
        $scope.showSelected = function(node, $parentNode) {
            var deffer = $q.defer();
            //获取当前树的父节点，用于删除开始
            $timeout(function() {
                if ($parentNode === null) {
                    $scope.parentNode = {
                        isRoot: true,
                        CHILDREN: $scope.dataForTheTree
                    };
                    $scope.selectedNode.parentNode = $scope.parentNode;
                } else {
                    $scope.parentNode = $parentNode;
                }
            }, 100);
            //获取当前树的父节点，用于删除结束
            $scope.params = {
                typeid: "dicttool",
                serviceid: $scope.url,
                modelid: "getNodeInfo",
                nodeId: node.id
            };
            $scope.isRoot = false;
            //trsHttpService.httpServer('/dicttool/' + $scope.url + '/getNodeInfo/', $scope.params, 'get').then(function(data) {
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'get').then(function(data) {
                //重置创建文件表单
                $scope.createForm.$setPristine();
                //当点击非叶子节点（文件夹）时出现的页面
                $scope.nodeId = node.id;
                if (node.type === "dir") {
                    //声明文件夹数据对象，为文件夹说明赋值
                    $scope.folder = {};
                    $scope.folder.instruction = data.content.replace(/~/g, "\n");
                    $scope.folder.dictName = data.dictName;
                    $scope.switch = {
                        create: false,
                        folder: true,
                        file: false,
                    };
                } else {
                    $scope.file = {};
                    $scope.file.instruction = data.content.replace(/~/g, "\n");
                    $scope.file.dictName = data.dictName;
                    $scope.switch = {
                        create: false,
                        folder: false,
                        file: true,
                    };
                }
                $scope.instruction = "";
                $scope.dictName = "";
                deffer.resolve();
            }, function(data) {});
            return deffer.promise;
        };
        $scope.selectRoot = function() {
            $scope.switch = {
                create: false,
                folder: true,
                file: false,
            };
            $scope.isRoot = true;
            $scope.selectedNode = {};
            $scope.folder = {
                instruction: $scope.module,
                dictName: $scope.module
            };
        };
        $scope.showToggle = function(node) {
            // node.CHILDREN = [];
            if (!angular.isDefined(node.CHILDREN)) {
                var params = {
                    typeid: "dicttool",
                    serviceid: $scope.url,
                    modelid: "getChildren",
                    parentId: node.id
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                    node.CHILDREN = data;
                });
            }
        };

        function init() {
            $scope.params = {
                condition: 'id=area_002001'
            };
            $scope.treeOptions = {
                nodeChildren: "CHILDREN",
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: "a1",
                    li: "a2",
                    liSelected: "a7",
                    iExpanded: "a3",
                    iCollapsed: "a4",
                    iLeaf: "a5",
                    label: "a6",
                    labelSelected: "rolegrouplabselected"
                },
                isLeaf: function(node) {
                    return node.type == "file";
                }
            };
            //树配置结束
            $scope.module = $stateParams.name;
            getInitTree($stateParams.type);
            $scope.url = $stateParams.type;
        }
        //同步分类到CKM服务器
        $scope.SynchronousData = function() {
            $modal.open({
                templateUrl: "./manageConfig/sysManageMent/classifiedDictionary/classification/synchronous/synchronous_tpl.html",
                scope: $scope,
                windowClass: 'toBeCompiled-synchronousModel-window',
                backdrop: true,
                controller: "synchronousCtrl"
            });
        };
        //搜索方法开始
        $scope.search = function() {
            console.log($scope.url + "===" + $scope.searchWord);
            var params = {
                typeid: "dicttoolPort",
                serviceid: $scope.url,
                modelid: "findByName",
                condition: "dictName=%" + $scope.searchWord + "%"
            };
            if ($scope.searchWord === "" || $scope.searchWord === undefined) {
                getInitTree($scope.url);
            } else {
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                    delete $scope.selectedNode;
                    delete $scope.expanded;
                    delete $scope.dataForTheTree;
                    $scope.dataForTheTree = data;
                    $scope.expanded = [];
                    expandTreeNoSelected($scope.dataForTheTree);
                    selectedSearchNode($scope.dataForTheTree);
                });
            }
        };

        function selectedSearchNode(treeData) {
            if (angular.isArray(treeData)) {
                if (treeData[0]) {
                    $scope.showSelected(treeData[0], {
                        isRoot: true,
                        CHILDREN: treeData
                    }).then(function() {
                        if (treeData[0].CHILDREN) {
                            selectedSearchNode(treeData[0]);
                        }
                    });
                }
            } else {
                if (treeData.CHILDREN) {
                    $scope.showSelected(treeData.CHILDREN[0], treeData.CHILDREN[0].parentNode).then(function() {
                        if (treeData.CHILDREN[0].CHILDREN) {
                            selectedSearchNode(treeData.CHILDREN[0]);
                        }
                    });
                }
            }
        }

        function expandTreeNoSelected(treeData) {
            if (angular.isArray(treeData)) {
                if (treeData.length > 0) {
                    for (var i = 0; i < treeData.length; i++) {
                        if (treeData[i].CHILDREN) {
                            $scope.expanded.push(treeData[i]);
                            expandTreeNoSelected(treeData[i]);
                        }
                    }
                }
            } else {
                if (treeData.CHILDREN) {
                    if (treeData.CHILDREN.length > 0) {
                        for (var j = 0; j < treeData.CHILDREN.length; j++) {
                            if (treeData.CHILDREN[j].CHILDREN) {
                                $scope.expanded.push(treeData.CHILDREN[j]);
                                expandTreeNoSelected(treeData.CHILDREN[j]);
                            }
                        }
                    }
                }
            }
        }
        $scope.deleteNode = function() {
            modalDialog.alertType("确认删除", "您确定要删除么", "warning", true, function() {
                var params = {
                    typeid: "dicttool",
                    serviceid: $scope.url,
                    modelid: "deleteNode",
                    nodeId: $scope.selectedNode.id
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                    //trsHttpService.httpServer('/dicttool/' + $scope.url + '/deleteNode', params, 'get').then(function(data) {
                    if ("success" === "success") {
                        var deleteIndex;
                        angular.forEach($scope.parentNode.CHILDREN, function(data, index, array) {
                            if (data.id === $scope.selectedNode.id) {
                                deleteIndex = index;
                            }
                        });
                        $timeout(function() {
                            if ($scope.parentNode instanceof Array) {
                                $scope.parentNode.splice(deleteIndex, 1);
                            } else {
                                $scope.parentNode.CHILDREN.splice(deleteIndex, 1);
                            }
                        }, 100);
                        if ($scope.parentNode.isRoot) {
                            $scope.selectRoot();
                        } else {
                            $scope.showSelected($scope.parentNode, $scope.parentNode.parentNode);
                        }
                    } else {
                        modalDialog.alertType("删除失败", data, "warning", false, function() {});
                    }
                });
            });
        };
        $scope.createFileOrFolder = function(type) {
            $scope.switch = {
                create: true,
                folder: false,
                file: false,
            };
            $scope.dictName = "";
            $scope.instruction = "";
            $scope.createType = type;
        };
        //保存新建文件或文件夹
        $scope.saveCreate = function() {
            /*if ($scope.nodeId === undefined) {
                modalDialog.alertType("请先选择节点", "请先选择节点", "warning", false, function() {});
                return;
            }*/
            var params = {
                "typeid": "dicttool",
                "serviceid": $scope.url,
                "modelid": "addNode",
                "nodeId": $scope.nodeId,
                "dictName": $scope.dictName,
                "content": angular.copy($scope.instruction).replace(/\n/g, "~").replace(/\"/g, "'").replace(/\\/g, "")
            };
            if ($scope.isRoot) {
                params.nodeId = "";
            }
            var newNode = {
                "dictName": $scope.dictName,

            };
            // var url = "/dicttool/" + $scope.url + "/addNode";
            if ($scope.createType === "file") {
                params.type = "file";
                newNode.type = "file";
            } else {
                params.type = "dir";
                newNode.type = "dir";
                newNode.CHILDREN = [];
            }
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType("新建成功", "", "success", false, function() {});
                data = data.replace(/"/g, "").replace(/\n/, "");
                newNode.id = data;
                if ($scope.isRoot)
                    $scope.dataForTheTree.push(newNode);
                else
                    $scope.selectedNode.CHILDREN.push(newNode);
                $scope.expanded.push(newNode);
                $scope.switch = {
                    create: false,
                    folder: true,
                    file: false,
                };
            }, function(data) {});
        };
        //删除文件或文件夹方法开始

        //更改保存地域分类数据
        $scope.saveClassficationData = function(type) {
            if ($scope.nodeId === undefined) {
                modalDialog.alertType("请先选择节点", "请先选择节点", "warning", false, function() {});
                return;
            }
            var params = {
                "typeid": 'dicttool',
                "serviceid": $scope.url,
                "modelid": 'update',
                "condition": "id=" + $scope.nodeId,
            };
            if (type === 'file') {
                params.dictName = $scope.file.dictName;
                params.content = angular.copy($scope.file.instruction).replace(/\n/g, "~").replace(/\"/g, "'").replace(/\\/g, "");
            } else {
                params.dictName = $scope.folder.dictName;
                params.content = angular.copy($scope.folder.instruction).replace(/\n/g, "~").replace(/\"/g, "'").replace(/\\/g, "");
            }
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                data = data.replace(/"/g, "").replace(/\n/g, "");
                //trsHttpService.httpServer('/dicttool/' + $scope.url + '/update', params, 'post').then(function(data) {
                // $scope.content=$scope.dataForTheTree;
                if (data === "success") {
                    $scope.selectedNode.dictName = params.dictName;
                    modalDialog.alertType("保存成功", data, "success", false, function() {});
                } else {
                    modalDialog.alertType("保存失败", data, "warning", false, function() {});
                }
            }, function(data) {});

        };

        function getInitTree(url) {
            if (!angular.isDefined(url)) {
                return;
            }
            var params = {
                typeid: "dicttool",
                serviceid: url,
                modelid: "getRootLevel",
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                //trsHttpService.httpServer('/dicttool/' + url + '/getRootLevel', "", 'get').then(function(data) {
                $scope.dataForTheTree = data;
                //默认树显示
                $scope.tree = {
                    display: true
                };
                //树的初始化展开
                /*$timeout(function() {
                    $scope.expanded.push($scope.dataForTheTree[0]);
                }, 100);*/
                // $scope.content=$scope.dataForTheTree;
            }, function(data) {
                $scope.dataForTheTree = [];
            });
        }

    }]);
